/**
 * @file resources.ts
 * @description Static requires of the six UI translation catalogs.
 * @module i18n
 */
import de_DE from "../../locales/de_DE.json";
import en_US from "../../locales/en_US.json";
import es_ES from "../../locales/es_ES.json";
import fr_FR from "../../locales/fr_FR.json";
import it_IT from "../../locales/it_IT.json";
import pt_BR from "../../locales/pt_BR.json";

/**
 * The single i18next namespace. Namespacing in this app is key structure
 * (`nav.*`, `settings.*`, `reports.*`), not file separation — per-namespace
 * file loading needs a backend plugin and there is no asset host (SE-6507).
 */
export const I18N_NAMESPACE = "translation";

/**
 * All six catalogs, bundled statically.
 *
 * Deliberately NOT lazy-loaded: no workflow publishes the web bundle and
 * `eas update` ships mobile JS as one OTA payload, so a dynamic import has
 * nowhere to load from. See `locales/README.md`.
 */
export const resources = {
  en_US: { [I18N_NAMESPACE]: en_US },
  es_ES: { [I18N_NAMESPACE]: es_ES },
  pt_BR: { [I18N_NAMESPACE]: pt_BR },
  fr_FR: { [I18N_NAMESPACE]: fr_FR },
  de_DE: { [I18N_NAMESPACE]: de_DE },
  it_IT: { [I18N_NAMESPACE]: it_IT },
} as const;

/** Locale codes that have a bundled catalog, in offer order. */
export const CATALOG_LOCALES = Object.keys(resources) as readonly string[];
